module.exports = __webpack_public_path__ + "static/media/kasundifishtikka.ee59a3fd.jpg";